/* import __COLOCATED_TEMPLATE__ from './user-nav.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();